/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import React from 'react';
import Alert from '../components/Alert';

export default class E404 extends React.Component {

    render() {
        return (<div className="container-fluid"><h1>Error 404</h1><Alert type="danger" message="Page not found." icon="ExclamationTriangle" /></div >);
    }
}